import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[app-padding]'
})
export class PaddingDirective {

  constructor(private el: ElementRef) {
    this.el.nativeElement.style.padding = '10px';
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/directives/padding.directive.ts